var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8733 12.0114C9.80254 12.8402 8.45891 13.3334 7.00008 13.3334C3.50228 13.3334 0.666748 10.4979 0.666748 7.00008C0.666748 3.50228 3.50228 0.666748 7.00008 0.666748C10.4979 0.666748 13.3334 3.50228 13.3334 7.00008C13.3334 8.79865 12.5837 10.4221 11.3797 11.575L14.5691 14.7644C14.6993 14.8946 14.6993 15.1056 14.5691 15.2358C14.4389 15.366 14.2279 15.366 14.0977 15.2358L10.8733 12.0114ZM12.6667 7.00008C12.6667 10.1297 10.1297 12.6667 7.00008 12.6667C3.87047 12.6667 1.33341 10.1297 1.33341 7.00008C1.33341 3.87047 3.87047 1.33341 7.00008 1.33341C10.1297 1.33341 12.6667 3.87047 12.6667 7.00008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.4781d0a2585c25787a5e9ea14bacedf4.svg";
export { ForwardRef as ReactComponent };